import React from "react";
import PropTypes from "prop-types";

import Button from "../../component/button/Button";
import TextInput from "../../component/input/TextInput";
import HeaderTag from "../../component/smallComponents/HeaderTag";

const CreateModeModal = ({ values, onChange }) => {
  return (
    <div
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      id="dark-header-modal"
      className="modal fade"
      aria-labelledby="create-rules-modal"
    >
      <div className="modal-dialog modal-full-width">
        <div className="modal-content">
          <div className="modal-header modal-colored-header bg-dark">
            <HeaderTag
              type="h4"
              className="modal-title"
              id="create-rules-modal"
              title="Create New Mode"
            />
            <Button
              title="x"
              type="button"
              className="close"
              aria-hidden="true"
              data-dismiss="modal"
              isBackgroundColor={false}
            />
          </div>
          <form className="pl-3 pr-3" onSubmit={() => {}}>
            <div className="modal-body">
              <div className="row">
                <div className="col-lg-3 col-md-3 col-xl-3 col-sm-3">
                  <TextInput
                    type="text"
                    label="Mode Name"
                    placeholder="Mode Name Ex.MODE 1"
                    required={true}
                    textWhite={false}
                    value={values.modeName}
                    htmlFor="modeName"
                    onChange={onChange}
                    name="modeName"
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

CreateModeModal.propTypes = {
  // loading: PropTypes.bool.isRequired,
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired
  // locations: PropTypes.array.isRequired,
  // inTimeString: PropTypes.string.isRequired,
  // outTimeString: PropTypes.string.isRequired,
  // onCreateRulesSubmit: PropTypes.func.isRequired,
  // onforLocationChange: PropTypes.func.isRequired,
  // currentUser: PropTypes.object.isRequired
};

export default CreateModeModal;
